import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyFormatService } from './currency-format.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class CurrencyFormatModule {}
